// angular import
import { Component, OnInit, Renderer2 } from '@angular/core';

// project import
import { AppConfig } from 'src/app/app-config';
import { ThemeService } from 'src/app/theme/shared/service/theme.service';

@Component({
  selector: 'app-configuration',
  standalone: true,
  imports: [],
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.scss'
})
export class ConfigurationComponent implements OnInit {
  rtlLayout!: boolean;
  bodyColor!: string;
  darkLayout!: boolean;
  boxLayout!: boolean;
  headerColor!: string;
  navbarColor!: string;
  fontFamily!: string;
  themeLayout!: string;

  constructor(
    private renderer: Renderer2,
    public themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'berry-ltr');
    if ((this.rtlLayout = AppConfig.isRtl_layout)) {
      this.renderer.addClass(document.body, 'berry-rtl');
      this.renderer.removeClass(document.body, 'berry-ltr');
    }
    if ((this.darkLayout = AppConfig.isDarkMode)) {
      this.renderer.addClass(document.body, 'berry-dark');
      this.themeService.isDarkTheme.set(this.darkLayout);
    }
    if ((this.boxLayout = AppConfig.isBox_container)) {
      (document.querySelector('.coded-content') as HTMLDivElement)?.classList.add('container');
    }
    if ((this.bodyColor = AppConfig.theme_color)) {
      (document.querySelector('body') as HTMLBodyElement).part.add(this.bodyColor);
    }
    if ((this.fontFamily = AppConfig.font_family)) {
      this.renderer.setStyle(document.body, 'font-family', `"${this.fontFamily}", sans-serif`);
    }
    if ((this.themeLayout = AppConfig.layout)) {
      document.querySelector('.coded-navbar')?.classList.add(this.themeLayout);
      this.themeService.sidebarLayout.set(this.themeLayout);
    }
  }
}
